// src/pages/NotFound.tsx
import { motion } from 'framer-motion';
import { Button } from '@/components/ui/button';
import { Home } from 'lucide-react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';

const NotFound = () => {
  return (
    <div className="min-h-screen">
      <Navbar />
      
      <main className="pt-16">
        <div className="container-custom py-24 flex flex-col items-center justify-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="text-center"
          >
            <h1 className="text-9xl font-bold text-stone-800 mb-4">404</h1>
            <h2 className="text-3xl font-semibold text-stone-600 mb-8">Stran ni bila najdena</h2>
            <p className="text-lg text-stone-500 mb-12 max-w-xl mx-auto">
              Oprostite, stran, ki jo iščete, ne obstaja. Morda je bila premaknjena ali izbrisana.
            </p>
            <Button size="lg" asChild>
              <Link to="/" className="flex items-center gap-2">
                <Home size={16} /> Nazaj na domačo stran
              </Link>
            </Button>
          </motion.div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default NotFound;